function TextShapeCore() {

}

TextShapeCore.TEXT_SHAPE_NONE = "none";
TextShapeCore.TEXT_SHAPE_ARC = "arc";
TextShapeCore.TEAM_NAME_TYPE = "team_name";
TextShapeCore.PLAYER_NAME_TYPE = "player_name";
TextShapeCore.TEXT_SHAPE_TYPE = "embellishments";
TextShapeCore.TEXT_SHAPE_LAYOUT_TYPE = "text_shape";
TextShapeCore.TEXT_SHAPE_LAYOUT_NEXT_TEXT = "next";
TextShapeCore.TEXT_SHAPE_LAYOUT_PREVIOUS_TEXT = "previous";

TextShapeCore.utilities = {
    init: function() {
        // let applications = ub.current_material.settings.applications;

        // if (_.isEmpty(applications)) { return; }

        // TextShapeCore.funcs.checkApplicationsDefaultTextShape(applications);
        _.each(ub.current_material.settings.applications, (app)=> {
            if (app.application_type === "free") return;
            if (app.defaultTextShapeLayout) {
                TextShapeCore.funcs.addTextShapeConfiguration(app, app.defaultTextShapeLayout);
                delete ub.current_material.settings.applications[app.code].defaultTextShapeLayout;
                ub.funcs.deactivateMoveTool();
            }
        })
    },

    isTextShape: function(code) {
        var application = ub.funcs.getApplicationSettings(code);

        if (typeof application !== "undefined") {
            if (application.text_type === TextShapeCore.TEXT_SHAPE_LAYOUT_TYPE || typeof application.textShapeConfig === "object") {
                return true;
            }
        }

        return false;
    },

    getTextShape: function(code) {
        var application = ub.funcs.getApplicationSettings(code);

        if (typeof application !== "undefined") {
            if (application.text_type === TextShapeCore.TEXT_SHAPE_LAYOUT_TYPE || typeof application.textShapeConfig === "object") {
                return application;
            }
        }

        return false;
    },

    getTextShapeByCategory: function(category, font) {
        var textShapes = _.find(ub.data.text_shapes, {
            font_name: font,
            category_name: category
        });
    
        return textShapes;
    },
    
    getTextShapeByDefault: function(category) {
        var textShapes = _.find(ub.data.text_shapes, {category_name: category, code: "default"});
        return textShapes;
    },

    trimCanvas: function(canvas) {
        var self = this;
        var ctx = canvas.getContext("2d");
        var width = canvas.width;
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var top = 0, bottom = imageData.height, left = 0, right = imageData.width;

        while (top < bottom && self.rowBlank(imageData, width, top)) ++top;
        while (bottom - 1 > top && self.rowBlank(imageData, width, bottom - 1)) --bottom;
        while (left < right && self.columnBlank(imageData, width, left, top, bottom)) ++left;
        while (right - 1 > left && self.columnBlank(imageData, width, right - 1, top, bottom)) --right;

        var trimmed = ctx.getImageData(left, top, right - left, bottom - top);
        var copy = canvas.ownerDocument.createElement("canvas");
        var copyCtx = copy.getContext("2d");
        copy.width = trimmed.width;
        copy.height = trimmed.height;
        copyCtx.putImageData(trimmed, 0, 0);

        return copy;
    },

    rowBlank: function(imageData, width, y) {
        for (var x = 0; x < width; ++x) {
            if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
        }
        return true;
    },

    columnBlank: function(imageData, width, x, top, bottom) {
        for (var y = top; y < bottom; ++y) {
            if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
        }
        return true;
    }
};

TextShapeCore.funcs = {
    addTextShapeConfiguration: function(application, code) {
        var self = this;
        // Set Application Configuration
        var fontObject = application.font_obj;
        var textShapeConfig = TextShapeCore.utilities.getTextShapeByCategory(code, fontObject.name);
        application.withPattern = false;
        application.withMascotPattern = false;

        // Arc Shape
        // if (code === "Arc") {
        //     textShapeConfig = ub.data.textShapeArcConfiguration;
        // }

        if (typeof textShapeConfig === "undefined") {
            textShapeConfig = TextShapeCore.utilities.getTextShapeByDefault(code);
            console.warn("Cannot find text shape configuration " + fontObject.name);
            console.info("Using Default Settings");
        }

        if (typeof textShapeConfig !== "undefined") {
            if (application.application_type !== TextShapeCore.TEXT_SHAPE_TYPE) {
                var application_type =  application.application_type;
                ApplicationCore.utilities.changeApp(application, TextShapeCore.TEXT_SHAPE_LAYOUT_TYPE, application_type);
            }

            application.text_shape_type = code;
            application.textShapeConfig = textShapeConfig;
            // Loading Start
            self.renderTextShape(application, function() {
                self.exportToPNG(application, function(image) {
                    ub.funcs.updateLayerTool();
                    ub.funcs.activateApplications(application.code);
                    self.clearCanvas();
                    // Loading End
                });
            });
        }
    },

    changeText: function(application, text) {
        var self = this;
        if (text.length === 0) {
            text = "sample text";
            $('.team-name-panel input.app-letters-input').val(text);
            $('#player-name-panel input.app-letters-input').val(text);
        }

        application.text = text;
        self.reloadTextShape(application);
    },

    changeFont: function(code, direction, font_id) {
        var self = this;
        var app = ub.funcs.getApplicationSettings(code);

        if (direction !== false) {
            newFont = ub.funcs.getFontObj(direction, app.font_obj, app.application_type);
        } else {
            newFont = _.find(ub.data.fonts, {id: font_id.toFixed()});
        }

        if (newFont !== undefined) {
            app.font_obj = newFont;

            if (app) {
                app.font_obj = newFont;
                self.reloadTextShape(app);
            }
        }
    },

    changeTextShape: function(application, code, callback) {
        var self = this;
        var fontObject = application.font_obj;
        var textShapeConfig = TextShapeCore.utilities.getTextShapeByCategory(code, fontObject.name);

        // Arc Shape
        // if (code === "Arc") {
        //     textShapeConfig = ub.data.textShapeArcConfiguration;
        // }

        if (typeof textShapeConfig === "undefined") {
            textShapeConfig = TextShapeCore.utilities.getTextShapeByDefault(code);
            console.warn("Cannot find text shape configuration " + fontObject.name);
            console.info("Using Default Settings");
        }

        if (code === "none") {
            ApplicationCore.funcs.createTextApplication(application, application.textLayoutType);
            return;
        } else {
            application.withPattern = false;
            application.withMascotPattern = false;
        }
        
        if (typeof textShapeConfig !== "undefined") {
            application.text_shape_type = code;
            application.textShapeConfig = textShapeConfig;
            self.reloadTextShape(application, callback);
        }
    },

    changeAccent: function(accentID, application) {
        var self = this;
        ApplicationCore.controllers.changeTextApplicationAccent(accentID, application);
        self.reloadTextShape(application);
    },

    changeColor: function(application, layer_name, layer_number, colorObject) {
        var self = this;
        // PROCEED
        var _layer = _.find(application.accent_obj.layers, {name: layer_name});
            _layer.default_color = colorObject.hex_code;
        
        // Save Color Array
        application.color_array[layer_number - 1] = colorObject;
        application.colorArrayText = _.pluck(application.color_array, "color_code");

        self.reloadTextShape(application, ()=> {
            $(".application-main-ui").scrollTop(999);
        });
    },

    renderTextShape: function(application, callback) {
        var self = this;
        var textShapeConfig = application.textShapeConfig;
        var font = textShapeConfig.font_size + 'px ' + application.font_obj.name;
        var text = application.text;
        
        var textShape = document.getElementById("textShapeCanvas");
        var ctx = textShape.getContext('2d');
        var width = textShape.width;
        var height = textShape.height;
        var isTri = false;
        var dltY;
        var angleSteps = 180 / width;
        var i = width;
        var y;
        var os = document.createElement('canvas');
        var octx = os.getContext('2d');

        os.width = width;
        os.height = height;
        octx.font = font;
        octx.textBaseline = 'top';
        octx.textAlign = 'center';

        var curve = parseFloat(textShapeConfig.curve, 10);
        var offsetY = parseFloat(textShapeConfig.offset_y, 10);
        var textHeight = parseInt(textShapeConfig.text_height, 10);
        var bottom = parseInt(textShapeConfig.bottom, 10);
        // var isTri = iTriangle.checked;

        octx.clearRect(0, 0, width, height);
        ctx.clearRect(0, 0, width, height);

        // Render Accent
        var accentCode = application.accent_obj.code;
        var colors = application.color_array;
        self.renderAccent(octx, text, width, accentCode, colors, textShapeConfig.font_size);
        
        octx.save();
        /// slide and dice
        i = width;
        dltY = curve / textHeight;
        y = 0;

        while (i--) {
            if (isTri) {
                y += dltY;
                if (i === (width * 0.5)|0) dltY = - dltY;
            } else {
                y = bottom - curve * Math.sin(i * angleSteps * Math.PI / 180);
            }

            ctx.drawImage(os, i, 0, 1, textHeight, i, height * 0.5 - offsetY / textHeight * y, 1, y);
        }

        if (_.isFunction(callback)) {
            callback();
        }
    },

    renderAccent: function(octx, text, width, accentCode, colorArray, fontSize) {
        var appColors = colorArray;
        var x = 0;
        var shadow = 0;

        octx.lineJoin = "round";
        switch (accentCode) {
            case "default":
                x = fontSize / 4;
                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width * 0.5, x);
                break;
            case "outlined":
                x = fontSize / 4;
                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 20;
                octx.strokeText(text, width * 0.5, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width * 0.5, x);
                break;
            case "single outline shadow":
                shadow = (fontSize / 3);
                x = fontSize / 4;
                // Shadow
                octx.fillStyle = "#" + appColors[2].hex_code;
                octx.fillText(text, width *  0.5, shadow);

                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 25;
                octx.strokeText(text, width * 0.5, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width * 0.5, x);
                break;
            case "double_outline":
                x = fontSize / 4;
                // Second Outline
                octx.strokeStyle = "#" + appColors[2].hex_code;
                octx.lineWidth = 40;
                octx.strokeText(text, width * 0.5, x);

                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 20;
                octx.strokeText(text, width * 0.5, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width * 0.5, x);
                break;
            case "drop_shadow":
                shadow = (fontSize / 3);
                x = fontSize / 4;
                
                // Shadow
                octx.fillStyle = "#" + appColors[1].hex_code;
                octx.fillText(text, width * 0.5, shadow);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width * 0.5, x);
                break;
            case "outlined_with_drop_shadow":
                shadow = (fontSize / 4) + 40;
                x = fontSize / 4;
                // Shadow
                octx.fillStyle = "#" + appColors[3].hex_code;
                octx.fillText(text, width * 0.5, shadow);

                // Second Outline
                octx.strokeStyle = "#" + appColors[2].hex_code;
                octx.lineWidth = 40;
                octx.strokeText(text, width * 0.5, x);

                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 20;
                octx.strokeText(text, width * 0.5, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width * 0.5, x);
                break;
            default:
                console.log("Invalid accent code");
                break;
        }
    },

    exportToPNG: function(application, callback) {
        var canvas = document.getElementById("textShapeCanvas");
        var trimCanvas = TextShapeCore.utilities.trimCanvas(canvas);
        var image = trimCanvas.toDataURL("image/svg");
        
        application.embellishment = {
            name: "Text Shape",
            png_filename: image,
            isBase64: true
        };

        var app_code = parseInt(application.code);
        // Update Embellishment
        ApplicationCore.utilities.updateEmbellishment(application.application, application.embellishment);

        ub.funcs.runAfterUpdate(app_code);

        if (_.isFunction(callback)) {
            callback(image);
        }
    },

    reloadTextShape: function(application, callback) {
        var self = this;
        var fontObject = application.font_obj;
        var textShapeConfig = TextShapeCore.utilities.getTextShapeByCategory(application.text_shape_type, fontObject.name);
        // Arc Shape
        // if (application.text_shape_type === "Arc") {
        //     textShapeConfig = ub.data.textShapeArcConfiguration;
        // }
        
        if (typeof textShapeConfig === "undefined") {
            textShapeConfig = TextShapeCore.utilities.getTextShapeByDefault(application.text_shape_type);
            console.warn("Cannot find text shape configuration " + fontObject.name);
            console.info("Using Default Settings");
        }

        if (application.text_shape_type === "none") {
            textShapeConfig = ub.data.textShapeNoneConfiguration;
        }


        if (typeof textShapeConfig !== "undefined") {
            application.textShapeConfig = ub.utilities.cloneObject(textShapeConfig);
            self.renderTextShape(application, function() {
                self.exportToPNG(application, function(image) {
                    _.delay(function() {
                        self.clearCanvas();
                    }, 1000);

                    ub.funcs.activateApplications(application.code);

                    if (typeof application.angle !== "undefined" && application.angle === "rotated") {
                        var rotation =  ub.data.rotatedValue;
                        ApplicationCore.utilities.rotateApplication(rotation, application.code);
                    }

                    ub.funcs.updateLayerTool();

                    if (_.isFunction(callback)) {
                        callback();
                    }
                });
            });
        }
    },

    clearCanvas: function() {
        var canvas = document.getElementById("textShapeCanvas");
        var context = canvas.getContext("2d");
        // Store the current transformation matrix
        context.save();

        // Use the identity matrix while clearing the canvas
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvas.width, canvas.height);

        // Restore the transform
        context.restore();
    },

    findTextShapeCategoryById: function(text_shape_id) {
        if (_.isEmpty(ub.data.text_shapes_category)) { return; } 
        return _.find(ub.data.text_shapes_category, { id: text_shape_id });
    },

    checkApplicationsDefaultTextShape: function(applications) {
        _.each(applications, app => {
            let layout = app.defaultTextShapeLayout;

            if (typeof layout === "undefined") { return; }

            TextShapeCore.funcs.addTextShapeConfiguration(app, layout);
        });
    }
};

TextShapeCore.customControllers = {

    // customTextShapeText: function(text, code){
    //     var self = this;
    //     var textShape = TextShapeCore.utilities.getTextShape(code);

    //     if (text.length === 0) {
    //         text = "sample text";
    //         $('.team-name-panel input.app-letters-input').val(text);
    //         $('#player-name-panel input.app-letters-input').val(text);
    //     }
    //     if (textShape) {
    //         textShape.text = text;
    //         TextShapeCore.customControllers.renderARC(textShape, TextShapeCore.TEXT_SHAPE_ARC, textShape.textLayoutType)
    //     }
    // },

    renderARC: function(application ,type, layout, callback){
        var _arcCanvas = document.getElementById("textShapeCanvasArc");
        var ctx = _arcCanvas.getContext('2d');

        var _height = _arcCanvas.height
        var _width = _arcCanvas.width

        var _arcAlign = "center";
        var _inwardFacing = true;
        var _fontSize = '150';
        var _kerning = 0;
        var _clockwise = 1;
        var _angleStart = 0;
        var _diameter = 3150;

        var os = document.createElement('canvas');
        var _arc = os.getContext('2d');

        os.width = _arcCanvas.width;
        os.height = _arcCanvas.height;

        _angleStart = _angleStart  * (Math.PI / 180);

        var _textHeight = 380;

        _arc.font = _fontSize + 'px' + ' ' + application.font_obj.name

        // Render Accent Color
        var accentCode = application.accent_obj.code;
        var colors = application.color_array;

         _arc.translate(_diameter / 2, _diameter / 2);
         _angleStart += (Math.PI * !_inwardFacing);
         _arc.textBaseline = 'middle';
         _arc.textAlign = 'center';

         if (_arcAlign == "center") {
            for (var i = 0; i < application.text.length; i++) {
                var _chardWidth = _arc.measureText(application.text[i]).width;
                _angleStart += ((_chardWidth + (i == application.text.length-1 ? 0 : _kerning)) / (_diameter / 2 - _textHeight)) / 2 * - _clockwise;
             }
         }

        _arc.rotate(_angleStart);

        for (var i = 0; i < application.text.length; i++) {
            var charWid = _arc.measureText(application.text[i]).width; // half letter
            // rotate half letter
            _arc.rotate((charWid/2) / (_diameter / 2 - _textHeight) * _clockwise); 
  
            TextShapeCore.customControllers.renderARCAccent(_arc, colors, _fontSize, application.text[i], _inwardFacing, _diameter, _textHeight, accentCode, _width);

            _arc.rotate((charWid/2 + _kerning) / (_diameter / 2 - _textHeight) * _clockwise); // rotate half letter
        }
        


        ctx.drawImage(os, 100, 100);

        if (application.application_type !== TextShapeCore.TEXT_SHAPE_TYPE) {
            var application_type =  application.application_type;
            ApplicationCore.utilities.changeApp(application, TextShapeCore.TEXT_SHAPE_LAYOUT_TYPE, application_type);
        }

        application.text_type = 'text_shape';
        application.text_shape_type = 'arc';

        this.exportToPNG(application, function(image) {
            TextShapeCore.customControllers.clearCanvas();
            ub.funcs.activateApplications(application.code);
            // UIkit.modal("#richardson-loading").hide();
            if (_.isFunction(callback)) {
                    callback();
                }
        })
    },

    renderARCAccent: function(octx, arrayColors, fontSize, text, facing, diameter, textHeight, accentCode){
        let appColors = arrayColors;
        let x = (facing ? 1 : -1) * (0 - diameter / 2 + textHeight / 2);
        let shadow = (fontSize / 6);
        let width = 0;

        octx.lineJoin = "round";
        switch (accentCode) {
            case "default":
                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width, x);
                break;
            case "outlined":
                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 20;
                octx.strokeText(text, width, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width, x);
                break;
            case "single outline shadow":
                // Shadow
                octx.fillStyle = "#" + appColors[2].hex_code;
                octx.fillText(text, width, x + shadow);

                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 25;
                octx.strokeText(text, width, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width, x);
                break;
            case "double_outline":
                // Second Outline
                octx.strokeStyle = "#" + appColors[2].hex_code;
                octx.lineWidth = 40;
                octx.strokeText(text, width, x);

                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 20;
                octx.strokeText(text, width, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width, x);
                break;
            case "drop_shadow":
                // Shadow
                octx.fillStyle = "#" + appColors[1].hex_code;
                octx.fillText(text, width, x + shadow);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width, x);
                break;
            case "outlined_with_drop_shadow":
                shadow = (fontSize / 4) + 15; 
                // Shadow
                octx.fillStyle = "#" + appColors[3].hex_code;
                octx.fillText(text, width, x + shadow);

                // Second Outline
                octx.strokeStyle = "#" + appColors[2].hex_code;
                octx.lineWidth = 40;
                octx.strokeText(text, width, x);

                // First Outline
                octx.strokeStyle = "#" + appColors[1].hex_code;
                octx.lineWidth = 20;
                octx.strokeText(text, width, x);

                // Main Text
                octx.fillStyle = "#" + appColors[0].hex_code;
                octx.fillText(text, width, x);
                break;
            default:
                console.log("Invalid accent code");
                break;
        }
    },

    renderTextShapeAccent: function(application, accentID){
        ApplicationCore.controllers.changeTextApplicationAccent(accentID, application);

        var textShape = TextShapeCore.utilities.getTextShape(application.code);

        TextShapeCore.customControllers.renderARC(textShape, TextShapeCore.TEXT_SHAPE_ARC, textShape.textLayoutType)
    },

    changeArcColor: function(application, layer_name, layer_number, colorObject) {
        // PROCEED
        var _layer = _.find(application.accent_obj.layers, {name: layer_name});
        _layer.default_color = colorObject.hex_code;
        
        // Save Color Array
        application.color_array[layer_number - 1] = colorObject;
        TextShapeCore.customControllers.renderARC(application, TextShapeCore.TEXT_SHAPE_ARC, application.textLayoutType);
    },

    changeArcText: function(application, text) {
        var self = this;
        if (text.length === 0) {
            text = "sample text";
            $('.team-name-panel input.app-letters-input').val(text);
            $('#player-name-panel input.app-letters-input').val(text);
        }

        application.text = text;
        self.renderARC(application);
    },

    changeTextArcFontStyle: function(code, direction, font_id) {
        var app = TextShapeCore.utilities.getTextShape(code)

        if (direction !== false) {
            newFont = ub.funcs.getFontObj(direction, app.font_obj);
        } else {
            newFont = _.find(ub.data.fonts, {id: font_id.toFixed()});
        }

        if (newFont !== undefined) {

            app.font_obj = newFont;

            if (_.contains(ub.data.scriptFonts, newFont.alias)) {
                app.text = ub.utilities.titleCase(app.text);
            } else {
                var text = app.text;
                app.text = text.toUpperCase();
            }

            // ub.textShapeModel.changeText(app.text);

            if (app) {
                    TextShapeCore.customControllers.renderARC(app, TextShapeCore.TEXT_SHAPE_ARC, app.textLayoutType, function() {
                        var font_style_el = $('#font-styles-container');

                        font_style_el.find('.font_name').text(newFont.caption);
                        font_style_el.find('.font_name').css('font-family', newFont.name);

                        font_style_el.find('.font-name').text(newFont.caption);
                        font_style_el.find('.font-name').css('font-family', newFont.name);

                        $('.team-name-panel input.app-letters-input').val(app.text);
                        $('#player-name-panel input.app-letters-input').val(app.text);

                        // UIkit.modal("#richardson-loading").hide();
                        
                    });
            }
            
            // if (app.textLayoutType === "team_name") {
            //     TailSweep.funcs.scriptAndBlockFontTailSweep(app, newFont);
            // }
        }
    },

    exportToPNG: function(application, callback) {
        var canvas = document.getElementById("textShapeCanvasArc");
        var trimCanvas = TextShapeCore.utilities.trimCanvas(canvas);
        var image = trimCanvas.toDataURL("image/svg");

        application.embellishment = {
            name: "Text Shape",
            png_filename: image,
            isBase64: true
        };

        var app_code = parseInt(application.code);
        // Update Embellishment
        ApplicationCore.utilities.updateEmbellishment(application.application, application.embellishment);

        ub.funcs.runAfterUpdate(app_code);

        if (_.isFunction(callback)) {
            callback(image);
        }
    },

    clearCanvas: function() {
        var canvas = document.getElementById("textShapeCanvasArc");
        var context = canvas.getContext("2d");
        // Store the current transformation matrix
        context.save();

        // Use the identity matrix while clearing the canvas
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvas.width, canvas.height);

        // Restore the transform
        context.restore();
    },
}